<div class="row">
    <div class="col">
      <button class='btn btn-info' (click)='newPriceList()'>New Price List</button>
    </div>
  </div>
  
  <div class="bg-primary pb-3">
    <app-grid
      entity='price-list'
      [filters]='this.plFilters'
      [columns]='this.plColumns'
      [buttons]='this.plButtons'
      [searchFilters]='this.plSearchFilters'
      [searchFields]='this.plSearchFields'
  ></app-grid>
  </div>
  